import CompactToDo from "domains/dashboard/components/CompactToDos/CompactToDo/CompactToDo";

export default CompactToDo;
